export const ATTRIBUTE_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  LINK: 'link',
  DATE: 'date',
  TIME: 'time',
  LIST: 'list',
  CHECKBOX: 'checkbox',
};
